<template>
    <div class="transfer-places-list">
        <el-row
            type="flex"
            justify="space-between"
        >
            <el-col>
                <el-button
                    style="margin: 0 5px;"
                    type="primary"
                    @click="_onAddButtonClick"
                >
                    Добавить
                </el-button>
            </el-col>
        </el-row>
        <el-table
            v-loading="isLoading"
            :data="places"
        >
            <el-table-column
                label="Название"
                prop="name"
            >
                <template slot-scope="scope">
                    {{ scope.row.name }}
                    <i
                        class="el-icon-edit-outline transfer-places-list__icon transfer-places-list__edit"
                        @click="_updatePlace(scope.row)"
                    />
                </template>
            </el-table-column>
            <el-table-column
                label="Информация"
                prop="description"
            />
            <el-table-column
                :width="60"
                align="center"
            >
                <template slot-scope="scope">
                    <i
                        class="el-icon-delete transfer-places-list__icon transfer-places-list__remove"
                        @click="_tryDeletePlace(scope.row)"
                    />
                </template>
            </el-table-column>
        </el-table>
        <el-row
            type="flex"
            justify="center"
        >
            <!--            <el-pagination-->
            <!--                    layout="total, prev, pager, next, sizes"-->
            <!--                    :current-page.sync="arrivalsMeta.current_page"-->
            <!--                    :page-count="arrivalsMeta.last_page"-->
            <!--                    :page-size="Number.parseInt(arrivalsMeta.per_page)"-->
            <!--                    :total="arrivalsMeta.total"-->
            <!--                    :page-sizes="[15, 30, 40, 50]"-->
            <!--                    @size-change="_onPageSizeChange"-->
            <!--                    @current-change="_onPageChange"-->
            <!--            />-->
        </el-row>
    </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapState } from 'vuex';
import ROUTES from '@/modules/transfer/enums/routes';

export default {
    name: 'TransferPlacesList',
    data() {
        return {
            isLoading: false
        };
    },
    computed: {
        ...mapState('transfer', [
            'places'
        ])
    },
    mounted() {
        // this.$router.push({ query: { ...this.$route.query, limit: this.$route.query.limit || 20 } });
        this._loadData();
    },
    methods: {
        ...mapActions('transfer', [
            'getPlaces',
            'deletePlace'
        ]),

        _onAddButtonClick() {
            this.$router.push({ name: ROUTES.TRANSFER_PLACES.ADD });
        },
        // _onChangeButtonClick(id) {
        //     this.$router.push({ name: ROUTES.ARRIVALS.FORM, params: { arrivalId: id } });
        // },
        _loadData() {
            this.isLoading = true;
            this.getPlaces({ params: this.$route.query })
                .then(() => {
                    this.isLoading = false;
                });
        },
        _tryDeletePlace(row) {
            let placeId = row.id;
            this.isLoading = true;
            this.deletePlace(placeId)
                .then((response) => {
                    if (response.success) {
                        this.$message.success(response.message);
                        return;
                    }
                    throw new Error(response.message);
                })
                .catch((error) => {
                    let message = _.get(error, 'response.data.message') || error.message;
                    this.$message.error(message);
                })
                .finally(() => {
                    this.isLoading = false;
                    this._loadData();
                });
        },
        _updatePlace: function(row) {
            this.$router.push({
                name: ROUTES.TRANSFER_PLACES.EDIT,
                params: {
                    transferPlaceId: row.id
                }
            });
        }

        // _onPageSizeChange(pageSize) {
        //     this.$router.push({ query: { ...this.$route.query, limit: pageSize, page: '1' } });
        //     this._loadData();
        // },
        //
        // _onPageChange(page) {
        //     this.$router.push({ query: { ...this.$route.query, page: page } });
        //     this._loadData();
        // },
        //
        // _onSearchChange: _.debounce(function (search) {
        //     this.$router.push({ query: { ...this.$route.query, search } });
        //     this._loadData();
        // }, 300),

    }
};
</script>

<style lang="scss">
.transfer-places-list {
  max-width: 800px;

  &__icon {
    font-size: 1.2em;
    cursor: pointer;
    visibility: hidden;
  }

  &__edit {
    color: #0486fe;
    margin-left: 10px;
  }

  &__remove {
    color: #eb2929;
  }

  .el-table__row {
    &:hover {
      .transfer-places-list__icon {
        visibility: visible;
      }
    }
  }
}
</style>
